export default __webpack_public_path__ + "static/media/warning--railroad-crossing-with-barriers--g7.a1fba766.png";